import { render, staticRenderFns } from "./AppearanceView.vue?vue&type=template&id=2892568d&scoped=true"
import script from "./AppearanceView.vue?vue&type=script&lang=js"
export * from "./AppearanceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2892568d",
  null
  
)

export default component.exports